import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http'

declare var Email : any;

@Injectable({
  providedIn: 'root'
})


export class SendEmailService {

  constructor(
    private http: HttpClient,
  ) { }
  
  options: any;
  body: any;
  baseUrl = "https://api.sendinblue.com/v3/contacts"
  apiKey = environment.sendInBlueKey;

  addContact(contact: Contact): Observable<any> {

    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    const todayString = yyyy + '-' + mm + '-' + dd;

    this.options = {
      headers: new HttpHeaders(
        {
          Accept: "application/json",
          'api-key': this.apiKey,
          'Content-Type': "application/json"
        }
      )
    }
    if (contact.phone === "") {
      this.body = {
        "updateEnabled": false,
        "email": contact.email,
        "listIds": [3],
        "attributes": {
          "FIRSTNAME": contact.name,
          "LASTNAME": contact.surname,
          "CREATION_DATE": todayString
        }
    } } else {
      this.body = {
        "updateEnabled": false,
        "email": contact.email,
        "listIds": [3],
        "attributes": {
          "FIRSTNAME": contact.name,
          "LASTNAME": contact.surname,
          "SMS": "+39" + contact.phone,
          "CREATION_DATE": todayString
        }
      }
    }
 
  return this.http.post(
    this.baseUrl, this.body, this.options)
  }

  sendEmail(contact: Contact) {
    console.log(contact);
    this.addContact(contact).subscribe(res => console.log(res));

    
    const body = (contact.type == "RCauto") ?
    `
    <i>Questo messaggio è generato automaticamente.</i> <br>
    <br>
    <b>Contatto: </b>${contact.email}<br> 
    <b>Targa: </b>${contact.targa}<br>
    <br>
    Dati ottenuti tramite form offerta RCauto
    `
    :
    `
    <i>Questo messaggio è generato automaticamente.</i> <br>
    <br>
    <b>Nome: </b>${contact.name} <br>
    <b>Cognome: </b>${contact.surname} <br> 
    <b>Email: </b>${contact.email}<br>
    <b>Telefono: </b>${contact.phone}<br>
    <b>Testo: </b>${contact.text}<br>
    `
    ;



/* `
    <i>Questo messaggio è generato automaticamente.</i> <br/>
     <b>Nome: </b>${contact.name} <br />
    <b>Cognome: </b>${contact.surname} <br /> 
    <b>Email: </b>${contact.email}<br /> <b>Subject: </b>subject<br /> <b>Message:</b> <br /> THATS A MESSAGE <br><br> <b>~End of Message.~</b> ` */

    Email.send({
    Host : "smtp.elasticemail.com",
    Username : "me.diego@yahoo.it",
    Password : environment.elasticPassword,
    To : "backoffice@francaviglia-assicurazioni.it",
    From : "me.diego@yahoo.it",
    Subject : "Nuovo contatto sito",
    Body : body
    }).then( message => { console.log(message) } ); 
      
    }
}
export class Contact {
  name: string;
  surname: string;
  targa: string;
  email: string;
  phone: string;
  text: string;
  type: string;
}
